import { cdnUrl } from "@/lib/cdn";

/**
 * A person's photo, or their initials on a soft brand ground when they have
 * none.
 */
export function Avatar({ photo, name, size = 40, className = "", ring = false }: { photo?: string | null; name?: string | null; size?: number; className?: string; ring?: boolean }) {
  const initials = String(name || "")
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase())
    .join("");
  const ringClass = ring ? "ring-2 ring-brand-light" : "";
  if (photo && photo !== "user.png") {
    // eslint-disable-next-line @next/next/no-img-element
    return <img src={cdnUrl(photo)} alt="" width={size} height={size} className={`shrink-0 rounded-full object-cover ${ringClass} ${className}`} style={{ width: size, height: size }} />;
  }
  return (
    <span
      className={`flex shrink-0 items-center justify-center rounded-full bg-brand-soft font-bold text-brand ${ringClass} ${className}`}
      style={{ width: size, height: size, fontSize: Math.round(size * 0.38) }}
      aria-hidden="true"
    >
      {initials || "?"}
    </span>
  );
}
